import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var PdfListRes;
export const PdfListTodo = createAsyncThunk('PdfList', async (data) => {
    // console.log("data", data)
    const type = localStorage.getItem('type')
    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'invoice_pdf',
            data: {
                "vso_code": "SR2401520"
            },
            headers: { "Content-Type": "application/json" },

        })
        return PdfListRes = res.data

    } catch (error) {
        return PdfListRes = error.response.data
    }
});

const PdfListSlice = createSlice({
    name: 'PdfList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(PdfListTodo.fulfilled, (state, action) => {
            state.data = action.payload;
            // console.log('userList', state.data)
        });
        builder.addCase(PdfListTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default PdfListSlice.reducer; 